import { render, staticRenderFns } from "./VerDetalleGrupo.vue?vue&type=template&id=e985a910"
import script from "./VerDetalleGrupo.vue?vue&type=script&lang=js"
export * from "./VerDetalleGrupo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports